import endsWith from 'lodash-es/endsWith';
import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux/actions';
import Route from 'react-router-dom/Route';
import { PAGE_ADMIN } from '../App';
import { Button } from '../components/actions';
import { getUser, selectIsUserAuthorized } from '../selectors';
import Footer from './Footer';
import Header from './Header';
import iconPlus from '../img/plus-icon.svg';
import iconList from '../img/list-icon.svg';
import s from './Admin.css';

const mapStateToProps = (state, ownProps) => ({
    isUserLoggedIn: selectIsUserAuthorized(state),
    userData: getUser(state),
});

class AdminLayout extends React.Component {
    render() {
        const { component: Component, isUserLoggedIn, userData, ...rest } = this.props;

        return (
            <Route
                {...rest}
                render={matchProps => {
                    const isOnUsers = matchProps.location.pathname.includes(PAGE_ADMIN.Users);
                    const isOnUserForm = matchProps.location.pathname.includes(PAGE_ADMIN.User + '/');
                    const locationContainsAdmin = isOnUsers || isOnUserForm ? true : false;

                    return (
                        <div>
                            <Header>
                                {isUserLoggedIn && userData && locationContainsAdmin && (
                                    <div className={s.sectionInner}>
                                        {(isOnUsers && (
                                            <Button
                                                onClick={this.handleCreatingNewUser}
                                                withBox={true}
                                                boxOnLeft={true}
                                                boxIcon={iconPlus}
                                                label="Create new user"
                                            />
                                        )) ||
                                            (isOnUserForm && (
                                                <Button
                                                    onClick={this.handleGoingToUsers}
                                                    withBox={true}
                                                    boxOnLeft={true}
                                                    boxIcon={iconList}
                                                    label="View users list"
                                                />
                                            ))}
                                    </div>
                                )}
                            </Header>

                            <div>
                                <Component {...matchProps} />
                            </div>

                            <Footer />
                        </div>
                    );
                }}
            />
        );
    }

    handleGoingToUsers = e => {
        this.props.dispatch(push(PAGE_ADMIN.Users));
    };

    handleCreatingNewUser = e => {
        this.props.dispatch(push(PAGE_ADMIN.User + '/new'));
    };
}

export default connect(mapStateToProps)(AdminLayout);



// WEBPACK FOOTER //
// ./app/web/src/layout/Admin.jsx